import { useIntl } from 'react-intl'
import { Link } from '@tanstack/react-router'
import { BrandMark } from '../layout/BrandMark'

// 404 — unknown route. Independent of auth state (unlike NotAuthorizedPage),
// so this page must not assume a Keycloak session exists.
export function NotFoundPage() {
  const intl = useIntl()

  return (
    <div data-id="notFoundPage-root" className="app-theme flex min-h-dvh items-center justify-center px-4">
      <div className="flex w-full max-w-[28rem] flex-col items-start gap-4">
        <BrandMark className="size-10 text-primary" />
        <p className="eyebrow">404</p>
        <h1 className="text-2xl font-semibold text-ink">{intl.formatMessage({ id: 'error.404.title' })}</h1>
        <p className="text-ink-soft">{intl.formatMessage({ id: 'error.404.description' })}</p>
        <Link
          to="/reports"
          data-id="notFoundPage-homeLink"
          className="mt-2 inline-flex h-10 items-center rounded-pill border border-rule bg-surface px-4 text-sm font-medium text-ink transition-colors duration-150 ease-move hover:border-rule-strong hover:bg-surface-2"
        >
          {intl.formatMessage({ id: 'error.404.backHome' })}
        </Link>
      </div>
    </div>
  )
}
